module.exports = __webpack_public_path__ + "4282232a7af0a202fa2637d86e2aa7d3.ttf";